
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39 14.397c0 3.538-2.006 6.836-5.44 9.288-3.43 2.45-8.222 3.998-13.56 3.998-5.338 0-10.13-1.547-13.56-3.998C3.005 21.233 1 17.935 1 14.397 1 10.86 3.006 7.562 6.44 5.11 9.87 2.66 14.66 1.112 20 1.112c5.338 0 10.13 1.547 13.56 3.997C36.995 7.562 39 10.86 39 14.397z","stroke":"#3DAFB8","stroke-width":"2"}}),_c('path',{attrs:{"d":"M15.767 8.688a2 2 0 012-2h9.268c2.28 0 4.152.732 5.616 2.196 1.512 1.44 2.268 3.228 2.268 5.364 0 1.728-.504 3.252-1.512 4.572-1.008 1.32-2.34 2.22-3.996 2.7l5.338 8.637a1.134 1.134 0 01-1.928 1.197l-5.343-8.568a2 2 0 00-1.697-.942h-7.638V30.7a1.188 1.188 0 01-2.376 0V8.688zm11.268.232h-8.892v10.692h8.892c1.536 0 2.832-.504 3.888-1.512 1.032-1.032 1.548-2.316 1.548-3.852 0-1.512-.528-2.772-1.584-3.78-1.032-1.032-2.316-1.548-3.852-1.548z","fill":"#000C1F"}})])
          )
        }
      }
    